import { writable } from 'svelte/store';

/**
 * This store is used as a device state for Loqed devices that are executing control commands.
 * The device ID is added to the store when a control command is sent to the device
 * and removed when the device sends a status update over socket, or on a timeout.
 */
const createLoqedPendingOperationsDevices = () => {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('loqedPendingOperationsDevices')) || {},
	);

	return {
		subscribe,
		set,
		add: (id, command) =>
			update((loqedPendingOperationsDevicesList) => {
				loqedPendingOperationsDevicesList[id] = command;
				return loqedPendingOperationsDevicesList;
			}),
		remove: (id) =>
			update((loqedPendingOperationsDevicesList) => {
				delete loqedPendingOperationsDevicesList[id];
				return loqedPendingOperationsDevicesList;
			}),
	};
};

export const loqedPendingOperationsDevices = createLoqedPendingOperationsDevices();
loqedPendingOperationsDevices.subscribe((val) =>
	localStorage.setItem('loqedPendingOperationsDevices', JSON.stringify(val)),
);
